export class StratoApiError extends Error {
  constructor({ code, message, status = 0, retryable = false, details = null }) {
    super(message);
    this.name = "StratoApiError";
    this.code = code || "internal_error";
    this.status = status;
    this.retryable = retryable;
    this.details = details;
  }
}

export const PUBLIC_ERROR_MESSAGES = {
  validation_error: "Controlla i dati inseriti e riprova.",
  unsupported_file_type: "Formato non supportato. Usa STL, STEP, STP o 3MF.",
  file_too_large: "Il file supera il limite di 50 MiB.",
  upload_url_expired: "Il link di upload è scaduto. Seleziona di nuovo il file.",
  upload_session_expired: "La sessione di upload è scaduta. Seleziona di nuovo il file.",
  upload_not_found: "Upload non trovato. Seleziona di nuovo il file.",
  invalid_state: "La richiesta non è nello stato corretto. Riprova tra poco.",
  unauthorized: "Sessione file non autorizzata. Seleziona di nuovo il file.",
  rate_limited: "Troppe richieste ravvicinate. Riprova tra poco.",
  not_found: "Codice o email non trovati.",
  cors_forbidden: "Origine non autorizzata per questa anteprima.",
  unsupported_content_type: "Non siamo riusciti a inviare i dati nel formato corretto.",
  invalid_json: "Non siamo riusciti a leggere la risposta del servizio.",
  timeout: "La richiesta sta impiegando troppo tempo. Riprova tra poco.",
  network_error: "Connessione non riuscita. Controlla la rete e riprova.",
  internal_error: "Non siamo riusciti a completare la richiesta. Riprova tra poco.",
};

export function publicMessageForCode(code, fallback) {
  return PUBLIC_ERROR_MESSAGES[code] || fallback || PUBLIC_ERROR_MESSAGES.internal_error;
}

export function normalizeApiError(error) {
  if (error instanceof StratoApiError) return error;

  if (error?.name === "AbortError") {
    return new StratoApiError({
      code: "timeout",
      message: PUBLIC_ERROR_MESSAGES.timeout,
      retryable: true,
    });
  }

  return new StratoApiError({
    code: "network_error",
    message: PUBLIC_ERROR_MESSAGES.network_error,
    retryable: true,
  });
}

export async function errorFromResponse(response) {
  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  const error = payload?.error || {};
  const code = error.code || (response.status === 404 ? "not_found" : "internal_error");
  return new StratoApiError({
    code,
    status: response.status,
    retryable: Boolean(error.retryable),
    message: publicMessageForCode(code, error.message),
    details: error.details || null,
  });
}
